import type {PropsWithChildren} from 'react'

import {DotcomLayoutRuntime} from '../dotcom-layout-runtime'
import {
  CollapsiblePageHeader as CorePageHeader,
  type CollapsiblePageHeaderProps,
} from '@github-ui/layout-primitives-core'

export type {CollapsiblePageHeaderProps} from '@github-ui/layout-primitives-core'

function Root(props: PropsWithChildren<CollapsiblePageHeaderProps>) {
  return (
    <DotcomLayoutRuntime>
      <CorePageHeader {...props} />
    </DotcomLayoutRuntime>
  )
}

Root.displayName = 'CollapsiblePageHeader'
export const CollapsiblePageHeader = Object.assign(Root, {...CorePageHeader})
